import React, { useEffect, useState } from "react";

// Components
import ShippingSkeleton from "./ShippingSkeleton";

// Icons
const deleteIcon = `${EASYCOMMERCE.assets}admin/img/icons/delete.png`;
const deletehoverIcon = `${EASYCOMMERCE.assets}admin/img/icons/delete-hover.png`;
const plusIcon = `${EASYCOMMERCE.assets}admin/img/icons/plusIcon.png`;

const shippingCountries = Object.keys(EASYCOMMERCE.shipping.countries).map(
	(key) => {
		return { value: key, label: EASYCOMMERCE.shipping.countries[key] };
	}
);

const AddShipping = ({ handleCancel, showToast, ShippingPlanId }) => {
	const [states, setStates] = useState([]);
	const [cities, setCities] = useState([]);
	const [isLoading, setIsLoading] = useState(false);
	const [shippingMethodList, setShippingMethodList] = useState([
		{
			name: "",
			min: 0,
			max: 0,
			cost: 0,
		},
	]);
	const [shippingRegionList, setShippingRegionList] = useState([
		{
			country: "",
			state: "",
			city: "",
		},
	]);
	const [shippingPlan, setShippingPlan] = useState({
		name: "",
		description: "",
		active: false,
		taxable: false,
		calculation_base: "",
		regions: [],
		methods: [],
	});

	const handleAddMethodRow = (index) => {
		const newShippingMethodList = [...shippingMethodList];
		newShippingMethodList.splice(index + 1, 0, {
			name: "",
			min: 0,
			max: 0,
			cost: 0,
		});
		setShippingMethodList(newShippingMethodList);
	};

	const handleAddRegionRow = (index) => {
		const newShippingRegionList = [...shippingRegionList];
		newShippingRegionList.splice(index + 1, 0, {
			country: "",
			state: "",
			city: "",
		});
		setShippingRegionList(newShippingRegionList);
	};

	const handleDeleteMethod = (index) => {
		shippingMethodList.length > 1 && shippingMethodList.splice(index, 1);
		setShippingMethodList([...shippingMethodList]);
	};

	const handleDeleteRegion = (index) => {
		shippingRegionList.length > 1 && shippingRegionList.splice(index, 1);
		setShippingRegionList([...shippingRegionList]);

		// delete specific state and city list
		const updatedStates = [...states];
		updatedStates.splice(index, 1);
		setStates(updatedStates);

		const updatedCities = [...cities];
		updatedCities.splice(index, 1);
		setCities(updatedCities);
	};

	const handleMethodItemChange = (value, index, key) => {
		const updatedList = [...shippingMethodList];
		updatedList[index][key] = value;
		setShippingMethodList(updatedList);
	};

	const handleSaveShipping = () => {
		const shippingData = {
			...shippingPlan,
			regions: shippingRegionList.map(
				(region) => `${region.country}-${region.state}-${region.city}`
			),
			methods: shippingMethodList,
		};

		if (!shippingData.name) {
			showToast("error", "Shipping plan name is required.");
			return;
		} else if (!shippingData.calculation_base) {
			showToast("error", "Calculation base is required.");
			return;
		}

		easycommerce_modal(true);

		fetch(`${EASYCOMMERCE.rest_base}/shipping-plans`, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				"X-WP-Nonce": EASYCOMMERCE.nonce,
			},
			body: JSON.stringify(shippingData),
		})
			.then((res) => res.json())
			.then((data) => {
				easycommerce_modal(false);
				if (data.success && data.data?.id) {
					showToast("success", data.data.message);
					handleCancel();
				} else {
					showToast("error", data.data.message);
				}
			});
	};

	const handleShippingRegionChange = (value, index, key) => {
		const updatedList = [...shippingRegionList];
		updatedList[index][key] = value;
		setShippingRegionList(updatedList);

		if (key === "country") {
			fetchAndStoreStates(value, index);
		} else if (key === "state") {
			fetchAndStoreCities(
				shippingRegionList[index].country,
				value,
				index
			);
		}
	};

	const fetchAndStoreStates = (country, index) => {
		fetch(`${EASYCOMMERCE.rest_base}/geo/states/${country}`,{
			headers: {
				"Content-Type": "application/json",
				"X-WP-Nonce": EASYCOMMERCE.nonce,
			}
		})
			.then((res) => res.json())
			.then((data) => {
				if (data.success && data.data?.states) {
					const updatedStates = [...states];
					updatedStates[index] = data.data.states;
					setStates(updatedStates);

					// reset specific state and city value in regionList
					const updatedRegionList = [...shippingRegionList];
					updatedRegionList[index].state = "";
					updatedRegionList[index].city = "";
					setShippingRegionList(updatedRegionList);
				}
			});
	};

	const fetchAndStoreCities = (country, state, index) => {
		fetch(`${EASYCOMMERCE.rest_base}/geo/cities/${country}?state=${state}`,{
			headers: {
				"Content-Type": "application/json",
				"X-WP-Nonce": EASYCOMMERCE.nonce,
			}
		})
			.then((res) => res.json())
			.then((data) => {
				if (data.success && data.data?.cities) {
					const updatedCities = [...cities];
					updatedCities[index] = data.data.cities;
					setCities(updatedCities);

					// reset specific city value in regionList
					const updatedRegionList = [...shippingRegionList];
					updatedRegionList[index].city = "";
					setShippingRegionList(updatedRegionList);
				}
			});
	};

	const handleUpdateShipping = () => {
		const shippingData = {
			...shippingPlan,
			regions: shippingRegionList.map(
				(region) => `${region.country}-${region.state}-${region.city}`
			),
			methods: shippingMethodList,
		};

		easycommerce_modal(true);

		fetch(`${EASYCOMMERCE.rest_base}/shipping-plans/${ShippingPlanId}`, {
			method: "PUT",
			headers: {
				"Content-Type": "application/json",
				"X-WP-Nonce": EASYCOMMERCE.nonce,
			},
			body: JSON.stringify(shippingData),
		})
			.then((res) => res.json())
			.then((data) => {
				easycommerce_modal(false);

				if (data.success) {
					showToast("success", "Shipping plan updated successfully.");
					handleCancel();
				} else {
					showToast("error", "Failed to update shipping plan.");
				}
			});
	};

	const updateStateAndCityLists = async (regions) => {
		const updatedStates = [];
		const updatedCities = [];

		// Track the total number of fetches
		const fetchPromises = regions.map((region, index) => {
			// Fetch states for the region
			return fetch(
				`${EASYCOMMERCE.rest_base}/geo/states/${region.country}`,{
					headers: {
						"Content-Type": "application/json",
						"X-WP-Nonce": EASYCOMMERCE.nonce,
					}
				}
			)
				.then((res) => res.json())
				.then((data) => {
					if (data.success && data.data?.states) {
						updatedStates[index] = data.data.states;

						// If the region has a state, fetch cities
						if (
							region.state &&
							data.data.states.includes(region.state)
						) {
							return fetch(
								`${EASYCOMMERCE.rest_base}/geo/cities/${region.country}?state=${region.state}`,{
									headers: {
										"Content-Type": "application/json",
										"X-WP-Nonce": EASYCOMMERCE.nonce,
									}
								}
							)
								.then((res) => res.json())
								.then((data) => {
									if (data.success && data.data?.cities) {
										updatedCities[index] = data.data.cities;
									}
								});
						}
					}
				});
		});

		// Wait for all fetches to complete
		await Promise.all(fetchPromises);

		// Update states and cities
		setStates(updatedStates);
		setCities(updatedCities);
	};

	useEffect(() => {
		if (!ShippingPlanId) return;

		setIsLoading(true);

		fetch(`${EASYCOMMERCE.rest_base}/shipping-plans?id=${ShippingPlanId}`,{
			headers: {
				"Content-Type": "application/json",
				"X-WP-Nonce": EASYCOMMERCE.nonce,
			}
		})
			.then((res) => res.json())
			.then(async (data) => {
				if (data.success && data.data?.id) {
					const fetchedPlan = data.data;

					// Map methods
					const methods = fetchedPlan.methods.map((method) => ({
						name: method.name,
						min: parseFloat(method.min),
						max: parseFloat(method.max),
						cost: parseFloat(method.cost),
					}));

					// Map regions
					const regions = fetchedPlan.regions.map((region) => {
						const [country, state, city] =
							region.region_code.split("-");
						return { country, state, city };
					});

					// Update state
					setShippingPlan({
						id: fetchedPlan.id,
						name: fetchedPlan.name,
						description: fetchedPlan.description,
						active: fetchedPlan.active,
						taxable: fetchedPlan.taxable || false,
						calculation_base: fetchedPlan.calculation_base,
						regions: regions,
						methods: methods,
					});

					setShippingRegionList(regions);
					setShippingMethodList(methods);

					// Update states and cities
					await updateStateAndCityLists(regions);
				}
			})
			.catch((error) => {
			})
			.finally(() => {
				setIsLoading(false); // Stop loading
			});
	}, [ShippingPlanId]);

	return (
		<>
			{!isLoading ? (
				<div className="bg-white mt-8">
					<div>
						<p className="flex items-center py-4">
							<label
								className="text-ec-body font-inter font-medium text-base leading-4 w-[180px]"
								htmlFor="easycommerce-shipping-name">
								Name
							</label>
							<div className="w-full">
								<div className="flex">
									<input
										onChange={(e) =>
											setShippingPlan({
												...shippingPlan,
												name: e.target.value,
											})
										}
										value={shippingPlan.name}
										type="text"
										className="easycommerce-shipping-input w-full focus:outline-none focus:shadow-none"
										placeholder="Shipping name here"
									/>
								</div>
							</div>
						</p>
						<p className="flex items-center py-4">
							<label
								className="text-ec-body font-inter font-medium text-base leading-4 w-[180px]"
								htmlFor="easycommerce-shipping-description">
								Description
							</label>
							<div className="w-full">
								<div className="flex">
									<input
										onChange={(e) =>
											setShippingPlan({
												...shippingPlan,
												description: e.target.value,
											})
										}
										value={shippingPlan.description}
										type="text"
										className="easycommerce-shipping-input w-full focus:outline-none focus:shadow-none"
										placeholder="Write description here"
									/>
								</div>
							</div>
						</p>
						<p className="flex items-center py-4">
							<label
								className="text-ec-body font-inter font-medium text-base leading-4 w-[180px]"
								htmlFor="easycommerce-shipping-description">
								Enable/Disable
							</label>
							<div className="w-full">
								<div className="flex">
									<label className="easycommerce-switch">
										<input
											type="checkbox"
											checked={shippingPlan.active}
											onChange={(e) => {
												setShippingPlan({
													...shippingPlan,
													active: e.target.checked,
												});
											}}
										/>
										<span className="easycommerce-slider easycommerce-round"></span>
									</label>
								</div>
							</div>
						</p>
						<p className="flex items-start py-4">
							<label
								className="text-ec-body font-inter font-medium text-base leading-4 w-[180px]"
								htmlFor="easycommerce-shipping-name">
								Regions
							</label>
							<div className="w-full">
								<div className="w-full border border-ec-border p-6 rounded-xl">
									<table className="w-full">
										<thead>
											<tr>
												<th className="w-[23%] text-start text-ec-body pb-2 text-sm font-normal leading-4 font-inter">
													Country
												</th>
												<th className="w-[23%] text-start text-ec-body pb-2 text-sm font-normal leading-4 font-inter">
													State
												</th>
												<th className="w-[23%] text-start text-ec-body pb-2 text-sm font-normal leading-4 font-inter">
													City
												</th>
												<th></th>
											</tr>
										</thead>
										<tbody>
											{shippingRegionList.map(
												(region, index) => (
													<tr>
														<td className="easycommerce-shipping-method-select-field">
															<select
																name={`easycommerce-shipping-${index}-region`}
																id={`easycommerce-shipping-${index}-region`}
																value={
																	region.country
																}
																onChange={(e) =>
																	handleShippingRegionChange(
																		e.target
																			.value,
																		index,
																		"country"
																	)
																}>
																<option value="">
																	Select
																	Country
																</option>
																{shippingCountries.length >
																	0 &&
																	shippingCountries.map(
																		(
																			country
																		) => (
																			<option
																				value={
																					country.value
																				}>
																				{
																					country.label
																				}
																			</option>
																		)
																	)}
															</select>
														</td>
														<td className="easycommerce-shipping-method-select-field">
															<select
																name={`easycommerce-shipping-${index}-state`}
																id={`easycommerce-shipping-${index}-state`}
																value={
																	region.state
																}
																onChange={(e) =>
																	handleShippingRegionChange(
																		e.target
																			.value,
																		index,
																		"state"
																	)
																}>
																<option value="">
																	Select State
																</option>
																{states.length >
																	0 &&
																	states[
																		index
																	] &&
																	states[
																		index
																	].length >
																		0 &&
																	states[
																		index
																	].map(
																		(
																			state
																		) => (
																			<option
																				value={
																					state
																				}>
																				{
																					state
																				}
																			</option>
																		)
																	)}
															</select>
														</td>
														<td className="easycommerce-shipping-method-select-field">
															<select
																name={`easycommerce-shipping-${index}-city`}
																id={`easycommerce-shipping-${index}-city`}
																value={
																	region.city
																}
																onChange={(e) =>
																	handleShippingRegionChange(
																		e.target
																			.value,
																		index,
																		"city"
																	)
																}>
																<option value="">
																	Select City
																</option>
																{cities.length >
																	0 &&
																	cities[
																		index
																	] &&
																	cities[
																		index
																	].length >
																		0 &&
																	cities[
																		index
																	].map(
																		(
																			city
																		) => (
																			<option
																				value={
																					city
																				}>
																				{
																					city
																				}
																			</option>
																		)
																	)}
															</select>
														</td>
														<td className="!w-[112px] flex easycommerce-shipping-method-select-field">
															<button
																onClick={() =>
																	handleAddRegionRow(
																		index
																	)
																}
																className="w-12 h-12 bg-[#F8F8F8] rounded-[4px] mx-2 flex items-center justify-center">
																<img
																	src={
																		plusIcon
																	}
																	alt=""
																/>
															</button>

															<button
																onClick={() =>
																	handleDeleteRegion(
																		index
																	)
																}
																className="w-12 h-12 bg-[#F8F8F8] rounded-[4px] flex items-center justify-center group hover:bg-[#FF3A521A]">
																<img
																	className="w-[14px] h-[16px] block group-hover:hidden"
																	src={
																		deleteIcon
																	}
																	alt="delete-pricing"
																/>
																<img
																	className="w-[14px] h-[16px] hidden group-hover:block"
																	src={
																		deletehoverIcon
																	}
																	alt="delete-pricing"
																/>
															</button>
														</td>
													</tr>
												)
											)}
										</tbody>
									</table>
								</div>
							</div>
						</p>
						{/* <p className="flex items-center py-4">
							<label
								className="text-ec-body font-inter font-medium text-base leading-4 w-[180px]"
								htmlFor="easycommerce-shipping-taxable">
								Taxable
							</label>
							<div className="w-full">
								<input
									id="easycommerce-shipping-taxable"
									className="easycommerce-input-checkoutbox"
									type="checkbox"
									checked={shippingPlan.taxable}
									onChange={(e) => {
										setShippingPlan({
											...shippingPlan,
											taxable: e.target.checked,
										});
									}}
								/>
							</div>
						</p> */}
						<p className="flex items-center py-4">
							<label
								className="text-ec-body font-inter font-medium text-base leading-4 w-[180px]"
								htmlFor="easycommerce-shipping-calculcution-base">
								Calculcution Base
							</label>
							<div className="w-full">
								<div className="flex">
									<select
										value={shippingPlan.calculation_base}
										onChange={(e) =>
											setShippingPlan({
												...shippingPlan,
												calculation_base:
													e.target.value,
											})
										}
										name="easycommerce-shipping-calculcution-base"
										id="easycommerce-shipping-calculcution-base"
										className="easycommerce-shipping-select w-full focus:outline-none focus:shadow-none">
										<option value="">Select Base</option>
										<option value="price">Price</option>
										<option value="weight">Weight</option>
										<option value="quantity">
											Quantity
										</option>
									</select>
								</div>
							</div>
						</p>
						<p className="flex items-start py-4">
							<label
								className="text-ec-body font-inter font-medium text-base leading-4 w-[180px]"
								htmlFor="easycommerce-shipping-name">
								Method
							</label>
							<div className="w-full">
								<div className="w-full border border-ec-border p-6 rounded-xl">
									<table className="w-full">
										<thead>
											<tr>
												<th className="w-[23%] text-start text-ec-body pb-2 text-sm font-normal leading-4 font-inter">
													Name
												</th>
												<th className="w-[23%] text-start text-ec-body pb-2 text-sm font-normal leading-4 font-inter">
													Fee
												</th>
												<th className="w-[23%] text-start text-ec-body pb-2 text-sm font-normal leading-4 font-inter">
													Min
												</th>
												<th className="w-[23%] text-start text-ec-body pb-2 text-sm font-normal leading-4 font-inter">
													Max
												</th>
												<th></th>
											</tr>
										</thead>
										<tbody>
											{shippingMethodList.map(
												(method, index) => (
													<tr>
														<td>
															<input
																className="easycommerce-shipping-method-input w-full"
																type="text"
																onChange={(e) =>
																	handleMethodItemChange(
																		e.target
																			.value,
																		index,
																		"name"
																	)
																}
																value={
																	method.name
																}
																placeholder="Write name here"
															/>
														</td>
														<td>
															<input
																className="easycommerce-shipping-method-input w-full"
																type="number"
																min={0}
																step={1}
																onChange={(e) =>
																	handleMethodItemChange(
																		e.target
																			.value,
																		index,
																		"cost"
																	)
																}
																value={
																	method.cost
																}
																placeholder="Write your fee"
															/>
														</td>
														<td>
															<input
																className="easycommerce-shipping-method-input w-full"
																type="number"
																min={0}
																step={1}
																onChange={(e) =>
																	handleMethodItemChange(
																		e.target
																			.value,
																		index,
																		"min"
																	)
																}
																value={
																	method.min
																}
																placeholder="120"
															/>
														</td>
														<td>
															<input
																className="easycommerce-shipping-method-input w-full"
																type="number"
																min={0}
																step={1}
																onChange={(e) =>
																	handleMethodItemChange(
																		e.target
																			.value,
																		index,
																		"max"
																	)
																}
																value={
																	method.max
																}
																placeholder="12222"
															/>
														</td>
														<td className="w-[112px] flex">
															<button
																onClick={() =>
																	handleAddMethodRow(
																		index
																	)
																}
																className="w-12 h-12 bg-[#F8F8F8] rounded-[4px] mx-2 flex 
																items-center justify-center">
																<img
																	src={
																		plusIcon
																	}
																	alt=""
																/>
															</button>

															<button
																onClick={() =>
																	handleDeleteMethod(
																		index
																	)
																}
																className="w-12 h-12 bg-[#F8F8F8] rounded-[4px] 
                                                    			flex items-center justify-center group hover:bg-[#FF3A521A]">
																<img
																	className="w-[14px] h-[16px] block group-hover:hidden"
																	src={
																		deleteIcon
																	}
																	alt="delete-pricing"
																/>
																<img
																	className="w-[14px] h-[16px] hidden group-hover:block"
																	src={
																		deletehoverIcon
																	}
																	alt="delete-pricing"
																/>
															</button>
														</td>
													</tr>
												)
											)}
										</tbody>
									</table>
								</div>
							</div>
						</p>
						<p className="mt-12 w-full flex justify-end items-center gap-3">
							<button
								id="easycommerce-reset-settings"
								className="w-20 h-12 flex justify-center items-center gap-[8px] font-inter bg-white group 
								border border-ec-primary px-4 rounded-lg text-ec-primary hover:text-white 
								hover:bg-ec-primary focus:shadow-none focus:text-white focus:bg-ec-secondary 
								lg:text-sm md:text-xs sm:text-sm transition-all ease-in-out duration-500 leading-[26px]"
								data-option_key="easycommerce-general-pages"
								onClick={handleCancel}>
								Cancel
							</button>
							<button
								onClick={
									ShippingPlanId
										? handleUpdateShipping
										: handleSaveShipping
								}
								id="easycommerce-save-settings"
								className="w-[180px] h-12 flex justify-center items-center rounded-lg border font-medium text-base 
                            	border-ec-primary bg-ec-primary text-white">
								{ShippingPlanId
									? "Update Shipping"
									: "Create Shipping"}
							</button>
						</p>
					</div>
				</div>
			) : (
				<ShippingSkeleton />
			)}
		</>
	);
};

export default AddShipping;
